









import {WConfTpl, WidgetDefinition, WParamTpl} from "@/components/widgets/WidgetFather"
import {bus} from "@/main"
import {defineComponent} from "@vue/composition-api"
import {extractParams, getTitle} from "@/components/widgets/hd/hdCommon"
import {executeQuery} from "@/data/repos/query"
import SimpleTextWidget from "@/components/widgets/SimpleTextWidget.vue"
import {formatNumberWithGrouping} from "@/data/sources/numbers"

export function config(): WidgetDefinition {
  return {
    ...WConfTpl.Text(),
    widget: "JobsAllocatedInAMonthPPMJobsCompleted",
    title: "In-house ppm jobs completed for month to date",
    _description: "",
    params: {
      hdCategory: {...WParamTpl.hdCategory(), _order: 1},
    },
  }
}

async function dataFetcher(params: any) {
  const p = extractParams(params)
  const r = await executeQuery(
    "FMS_DB",
    "inhousePPMJobsCompletedForMonth",
    {category: p.category, year: p.year, month: p.month})
  if (r[0].Label === "Completed") {
    return {value: formatNumberWithGrouping(r[0].Value)}
  } else {
    return {value: formatNumberWithGrouping(r[1].Value)}
  }
}

async function titleCallback(config: any) {
  return getTitle(config.params)
}

export default defineComponent({
  props: {config: {type: Object, required: true}},
  components: {SimpleTextWidget},
  setup(props, context) {
    context.emit("config-update", config())

    function chartClickCallback() {
      bus.$emit("chartPopup", {
        title: config().title + ": " + getTitle(props.config.params),
        component: () => import("@/components/drilldowns/JobsAllocatedInAMonthPPMJobsCompletedDrillDown.vue"),
        componentArgs: {...extractParams(props.config.params), status: 1},
      })
    }

    return {dataFetcher, chartClickCallback, titleCallback}
  },
})
